import useSWR, { SWRConfiguration, SWRResponse } from 'swr'

import useApiInteraction, { Parameters } from './useApiInteraction'

export type ApiSWRResponse<T> = SWRResponse<T, unknown>

interface UseApiSWRProps {
  method: 'GET' | 'POST'
  endpoint: string
  params: Parameters
  config?: SWRConfiguration
  enabled?: boolean
}

function useApiSWR<T>({
  method,
  endpoint,
  params,
  config,
  enabled = true,
}: UseApiSWRProps): ApiSWRResponse<T> {
  const { get, postWithUserToken, accessToken } = useApiInteraction<T>()

  return useSWR<T, unknown>(
    () => (enabled ? { endpoint, token: accessToken(), params } : null),
    method === 'GET' ? get : postWithUserToken,
    config
  )
}

export default useApiSWR
